import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { apiPut, apiGet } from '../../utils/apiFetch'
import ErrorMessage from 'components/ErrorMessage'
import apiPath from '../../utils/pathObj'
import useToastContext from 'hooks/useToastContext'
import FormDateRangePicker from 'components/shared/FormDateRangePicker'
import dayjs from 'dayjs'

const ReassignTask = ({ handleTask, allTaskScheduling, currentItem }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })
  const notification = useToastContext()
  const [recordsTemp, setRecordTemp] = useState('')
  const [cat, setCat] = useState('')
  const [selectStartDate, setSelectStartDate] = useState(currentItem.startDateTimeUTC)
  const [selectEndDate, setSelectEndDate] = useState(currentItem.endDateTimeUTC)
  const [dateErrors, setDateErrors] = useState({
    startDate: '',
    endDate: ''
  })

   const getEmployeeList = async () => {
    try {
      const res = await apiGet(apiPath.getEmployeeListTask, {})
      setRecordTemp(res?.data?.results)
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    getEmployeeList()
  }, [])

  const handleDateChange = (start, end) => {
    setSelectStartDate(dayjs(start).toDate())
    setSelectEndDate(dayjs(end).toDate())
  }

  const onSubmit = async data => {
  try {
    // Convert to UTC format exactly like your Edit component
    const payload = {
      employeeId: cat,
      startDateTime: selectStartDate ? new Date(selectStartDate).toISOString() : null,
      endDateTime: selectEndDate ? new Date(selectEndDate).toISOString() : null
    };

    
    // Uncomment your API call when ready
    const res = await apiPut(
      apiPath.taskReassign + '/' + currentItem._id,
      payload
    )
    if (res?.data?.success) {
      allTaskScheduling()
      handleTask(false)
      notification.success(res?.data?.message)
    } else {
      notification.error(res?.data?.message)
    }
  } catch (err) {
    console.log('err:', err)
  }
}

  const selectCategory = e => {
    if (e.target.value) {
      setCat(e.target.value)
      clearErrors('_id')
    } else {
      setCat('')
      setError('_id', {
        type: 'validation',
        message: 'Please select employee.'
      })
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[540px] max-h-[96vh] overflow-y-auto	'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('REASSIGN_TASK')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleTask(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0  w-full group'>
                      <select
                        type='select'
                        id='_id'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        value={cat}
                        {...register('_id', {
                          required: 'Please select employee name.'
                        })}
                        onChange={selectCategory}
                      >
                        <option value=''>{t('SELECT_EMPLOYEE_NAME')}</option>
                        {recordsTemp &&
                          recordsTemp.map(item => {
                            return (
                              <option key={item?._id} value={item?._id}>{item?.name}</option>
                            )
                          })}
                      </select>
                      <label
                        htmlFor='_id'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {' '}
                        {t('SELECT_EMPLOYEE_NAME')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?._id?.message} />
                    </div>
                  </div>
                    <div className='grid sm:grid-cols-2'>
                      <FormDateRangePicker
                        selectDateFrom
                        selectDateTo
                        handleDateChange={handleDateChange}
                        addFlex={false}
                        errors={dateErrors}
                        selectStartDate={selectStartDate}
                        selectEndDate={selectEndDate}
                      />
                    </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => handleTask(false)}
                >
                  {t('O_BACK')}
                </button>
                <button
                  className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                  onClick={handleSubmit(onSubmit)}
                >
                  {t('O_ADD')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default ReassignTask